<template>
  <!-------------------- END - Controles arriba de tabla-------------------->
  <div class="table-responsive">
    <!-------------------- Tabla de REsultados -------------------->
    <table class="table">
      <thead>
        <tr>
          <th scope="col" colspan="2">Cargo</th>
          <th style="width: 200px" scope="col">Total Abonado</th>
          <th scope="col" v-if="current.estado == 'A'"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="det in current.aplicacionabonocargo_set" v-bind:key="det.id">
          <td scope="col" colspan="2">
            <router-link target="_blank" class="text-dark"
              :to="{ name: 'cxp-cargo-editar', params: { id: det.cargo.id } }">
              Documento #{{ det.cargo.numero }} // Pendiente de Abonar: Q
              {{ det.cargo.total_pendiente }} &nbsp;
              <i class="fas fa-share fa-lg text-success"></i>&nbsp;<i class="far fa-file-alt fa-lg text-success"></i>
            </router-link>
          </td>
          <td class="text-right" scope="col">Q {{ det.valor_total }}</td>
          <td scope="col" v-if="current.estado == 'A'">
            <button class="btn btn-danger btn-sm" @click="eliminarAbonoACargo(det)">
              <i class="fas fa-minus"></i>
            </button>
          </td>
        </tr>
        <tr v-if="current.estado == 'A'">
          <td class="col-3">
            <div class="form-group">
              <label>Tipo de Cargo</label>
              <select class="form-control" autofocus="autofocus" v-model="apl_current.tipo_cargo"
                @change="refreshCargos()">
                <option v-for="(c, key) in tiposcargos" :value="c.id" :key="key">
                  {{ c.nombre }}
                </option>
              </select>
            </div>
          </td>
          <td>
            <div class="form-group">
              <label v-bind:class="{
                'text-danger':
                  apl_current.errors.cargo &&
                  apl_current.errors.cargo.length > 0,
              }">Cargo a Abonar</label>
              <select class="form-control" autofocus="autofocus" v-model="apl_current.cargo" @change="refreshTipoCargo">
                <option v-for="(c, key) in cargos" :value="c.id" :key="key">
                  Cargo #{{ c.numero }} // Saldo Pendiente: {{ c.total_pendiente }}
                </option>
              </select>
              <small v-if="apl_current.errors && apl_current.errors.cargo" class="form-text text-danger">{{
                apl_current.errors.cargo[0] }}</small>
            </div>
          </td>
          <td class="col-3">
            <div class="form-group">
              <label v-bind:class="{
                'text-danger':
                  apl_current.errors.valor_total &&
                  apl_current.errors.valor_total.length > 0,
              }">Saldo a Aplicar</label>
              <input v-model="apl_current.valor_total" class="form-control" placeholder="Monto" v-bind:class="{
                'is-invalid':
                  apl_current.errors.valor_total &&
                  apl_current.errors.valor_total.length > 0,
              }" type="number" step="0.05" />
              <small v-if="apl_current.errors && apl_current.errors.valor_total" class="form-text text-danger">{{
                apl_current.errors.valor_total }}</small>
            </div>
          </td>
          <td class="text-right">
            <button type="button" class="btn btn-sm btn-success" @click="agregarAbono">
              Abonar
              &nbsp;
              <i class="fas fa-money-bill-wave"></i>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
    <!-------------------- END - Basic Table -------------------->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import PaginationComponent from "@/components/utils/PaginationComponent";
import DynamicService from "@/services/commons/DynamicService";

export default {
  components: {
    PaginationComponent,
  },
  data() {
    return {
      data: [],
      cargos: [],
      apl_current: {
        tipo_cargo: null,
        cargo: null,
        valor_total: null,
        errors: {
          tipo_cargo: null,
          cargo: null,
          valor_total: null,
        },
      },
    };
  },
  computed: {
    ...mapGetters({
      tiposcargos: "cxpcargos/tipocargo",
    }),
  },
  props: ["current"],
  mounted() {
    let self = this;
    self.refreshTipoCargo();
  },
  methods: {
    refreshTipoCargo() {
      let self = this;
      self.$store.dispatch("cxpcargos/tipocargo", {
        activa: true,
        quitar_paginacion: true,
      });
    },
    refreshCargos() {
      let self = this;
      let params = {
        con_saldo_pendiente: "True",
        tipo_cargo: self.apl_current.tipo_cargo,
        proveedor: self.current.proveedor.codigo,
      };
      DynamicService.fetch("cxp", "cargos", params).then((res) => {
        self.cargos = res.data;
      });
    },
    agregarAbono() {
      let self = this;
      let params = self.apl_current;
      DynamicService.postAction(
        "cxp",
        "abonos",
        self.current.id,
        "aplicar_cargo",
        params
      )
        .then((res) => {
          self.$emit("refresh");
          self.refreshCargos();
          self.apl_current = {
            tipo_cargo: null,
            cargo: null,
            valor_total: null,
            errors: {
              tipo_cargo: null,
              cargo: null,
              valor_total: null,
            },
          };
        })
        .catch((error) => {
          console.log(error.response.data);
          self.apl_current.errors = error.response.data;
          self.$emit("refresh");
          self.refreshCargos();
        });
    },
    eliminarAbonoACargo(detalle) {
      let self = this;
      if (!confirm("¿Desea eliminar el abono al documento seleccionado?")) {
        return;
      }

      DynamicService.postAction(
        "cxp",
        "abonos",
        self.current.id,
        "eliminar_cargo_aplicado",
        {
          id: detalle.id,
        }
      )
        .then((res) => {
          self.$emit("refresh");
          self.refreshCargos();
        })
        .catch((error) => {
          console.log(error.response.data);
          self.$emit("refresh");
          self.refreshCargos();
        });
    },
  },
};
</script>
